import { VisitEvent } from "../scripts/visits.entities";
import { VisitLookup } from "../scripts/visits.lookup";



export class VisitSummarySeries {
    name: string;
    //data: Map<number, number>; //captures both status and completion timing; ID of visit status or timing completion
    type: string;
    typeId: number; //visitId, siteNumber, etc.
    sortValue: number;
    visits: Map<number, VisitEvent[]>;

    constructor(name: string, type: string, typeId: number) {
        this.name = name;
        //this.data = new Map<number, number>();        
        this.type = type;
        this.typeId = typeId;
        this.sortValue = (type == "visit") ? VisitLookup.GetVisitMasterOrdering(typeId) : 0;
        this.visits = new Map<number, VisitEvent[]>();
    }

    addVisitEvent(event: VisitEvent): void {

        //Visit status
        let count: number;
        let visitArray: VisitEvent[];
        //if (this.data.has(event.VisitStatusId)) { count = this.data.get(event.VisitStatusId); }
        //else { count = 0; }
        //this.data.set(event.VisitStatusId, ++count);
        if (this.visits.has(event.VisitStatusId)) { visitArray = this.visits.get(event.VisitStatusId); }
        else { visitArray = []; }
        visitArray.push(event);
        this.visits.set(event.VisitStatusId, visitArray);


        if (this.type == "site") {
            this.sortValue += 1;
        }

        if (event.VisitStatusId == 1) { //complete
            //if (this.data.has(event.DaysFromWindowId)) { count = this.data.get(event.DaysFromWindowId); }
            //else { count = 0; }
            //this.data.set(event.DaysFromWindowId, ++count);   
            if (this.visits.has(event.DaysFromWindowId)) { visitArray = this.visits.get(event.DaysFromWindowId); }
            else { visitArray = []; }
            visitArray.push(event);
            this.visits.set(event.DaysFromWindowId, visitArray);  
        } 
    }
}